window.addEventListener("DOMContentLoaded",()=>{
  document.querySelector(".subscription-widget__sub").click();
})
window.addEventListener("click",(event)=>{
  if(event.target.classList.contains('quantity-option-label-card') || event.target.closest('.quantity-option-label-card')){
   const allLabelCards=document.querySelectorAll('.quantity-option-label-card');
   allLabelCards.forEach(el=>{
    el.classList.remove('active')
   })
   
    const labelCard = event.target.classList.contains('quantity-option-label-card') ? event.target : event.target.closest('.quantity-option-label-card')
  
    labelCard.classList.add("active")
  
  }

})


window.addEventListener("change",(event)=>{
  if(event.target.classList.contains('quantity-radio-input') || event.target.closest('.quantity-radio-input')){
   const currentQty= event.target.classList.contains('quantity-radio-input') ?event.target : event.target.closest('.quantity-radio-input');
const currentQtyGlued=currentQty.value.replace(" ","").toLowerCase();
//console.log("currentQtyGlued",currentQtyGlued)
  let currentOptions= Array.from(document.querySelectorAll(".product-page-info__options .product-options .option_group .product-options__section .product-options__value.active")).map(el=>el.dataset.originalValue)
if(currentQty){
  const currentQtyValue = currentQty.value;
  currentOptions.push(currentQtyValue) 

}
const qtyToBeSelected= document.querySelector(`[data-quantity-container] [data-value='${currentQtyGlued}']`);
qtyToBeSelected.click();

/*
console.log("currentOptionscurrentOptionscurrentOptionscurrentOptionscurrentOptions",currentOptions)

const currentVariant=findVariantDependingOnOptions(currentOptions);

console.log("currentVariantcurrentVariantcurrentVariantcurrentVariant",currentVariant)
const currentVariantId = currentVariant.id;
const singleProduct= document.querySelector('single-product.product-page-main');
singleProduct.setAttribute("data-product-variant-id",currentVariantId)*/

}

if(event.target.classList.contains('subscription_choice_input') || event.target.closest('.subscription_choice_input'))
{
  //console.log("mehmehmehmehmehmehmeh")
  const currentSellingPlanValue=Number(document.querySelector('[name="selling_plan"]:checked').value);
  const newVariant = getVariant(Number(productElement.getAttribute('data-product-variant-id')));
  if(currentSellingPlanValue){
    adjustPackaging(newVariant,true)

  }
  else{
    adjustPackaging(newVariant,false)


  }
}

})
const findVariantDependingOnOptions=(currentOptions)=>{


  const currentVariant=currentProduct.variants.find(v=>arraysAreEqual(v.options,currentOptions));
  return currentVariant
};
function arraysAreEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  
  return true;
}

const productElement = document.querySelector('single-product');

if (productElement) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-product-variant-id'
      ) {
        const newVariantId = Number(productElement.getAttribute('data-product-variant-id'));
      //  console.log('Promenila se varijanta:', newVariantId);
        adjustVariant(newVariantId)
      }
    }
  });

  observer.observe(productElement, {
    attributes: true,
    attributeFilter: ['data-product-variant-id'],
  });
}

const getVariant=(newVariantId)=>{
  const newCurrentVariant = currentProduct.variants.find(v=> v.id ==newVariantId);
return newCurrentVariant;
}
const adjustVariant=(newVariantId)=>{

    const newCurrentVariant = currentProduct.variants.find(v=> v.id ==newVariantId);
    //console.log('newCurrentVariant',newCurrentVariant)
    adjustGalleryImages(newCurrentVariant);
    const hasSellingPlan=Number(document.querySelector('[name="selling_plan"]:checked').value)?true:false;
    adjustPackaging(newCurrentVariant,hasSellingPlan);

}
const  adjustPackaging=(newCurrentVariant, useSellingplans)=>{
const currentVariantOptions = [newCurrentVariant.option1,newCurrentVariant.option2]
   // console.log("currentVariantOptions",currentVariantOptions)

    const allVariantsWithSameOptions = currentProduct.variants.filter(v=>v.option1 ==newCurrentVariant.option1 && v.option2 ==newCurrentVariant.option2)

    //console.log("allVariantsWithSameOptionsallVariantsWithSameOptions",allVariantsWithSameOptions)

    const customPackagesWrapper=document.querySelector(".custom_packages_wrapper");

    allVariantsWithSameOptions.forEach(v=>{
      const package=v.option3;
      const currentVariant=v;
      let price=0;
      let compareAtPrice=0;
      const packageWrapper=customPackagesWrapper.querySelector(`input[value*='${package}']`).closest(".quantity-option-label-card");

      if(currentVariant.selling_plan_allocations.length > 0 && useSellingplans){

        price=currentVariant.selling_plan_allocations[0].price;
        compareAtPrice=currentVariant.selling_plan_allocations[0].compare_at_price;
      }
      else{

        price=currentVariant.price;
        compareAtPrice=currentVariant.compare_at_price;

      }
      const priceDom = packageWrapper.querySelector(".current-price");
      const comparePriceDom = packageWrapper.querySelector(".compare-price");

      
      priceDom.textContent=`${Shopify.formatMoney(price,theme.moneyFormat)}`
      if(comparePriceDom){
        comparePriceDom.textContent=`${Shopify.formatMoney(compareAtPrice,theme.moneyFormat)}`
      }


      //${Shopify.formatMoney(data.update_variant.selling_plan_allocations[0].price,theme.moneyFormat)}</span> <span>${Shopify.formatMoney(data.update_variant.price,theme.moneyFormat)}


     
      
     // console.log("packageeeeeeeeeeeeeeeeeeeeeeeeee",packageWrapper)
      
    })

}
const adjustGalleryImages=(variant)=>{
    const gallery=document.querySelector(".product-image-section .main-swiper");
    const variantImage = variant.featured_image.src;
    const imgToBeActive=Array.from(gallery.querySelectorAll('img')).find(img=> img.src.replace('_1024x1024','').includes(variantImage));
   const slideToBeActive=imgToBeActive.closest(".swiper-slide");
    let indx = 0;
    gallery.querySelectorAll(".swiper-slide").forEach((slide,index)=>{
        if(slide == slideToBeActive){
            indx=index;
        }
    })
   // console.log(indx)
    window.mainSwiper.slideTo(indx);
}



